import React from 'react';
import PropTypes from 'prop-types';

export default class SearchForm extends React.Component {
  static propTypes = {
    children: PropTypes.any,
    className: PropTypes.string,
    searchAction: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
    defaultValues: PropTypes.object,
    valueChangeDelay: PropTypes.number
  };

  static defaultProps = {
    valueOverride: true,
    valueChangeDelay: 500
  };

  constructor(props){
    super(props);
    this.renderFields = this.renderFields.bind(this);
    this.onValueChange = this.onValueChange.bind(this);
    this.executeSearch = this.executeSearch.bind(this);
    this.state = {
      data: Object.assign({}, props.defaultValues)
    }
  }

  componentDidMount(){
    // make sure default value isn't empty
    if (this.props.defaultValues && this.props.defaultValues.searchValue){
      this.executeSearch();
    }
  }

  componentWillReceiveProps(newProps){
    if(newProps.defaultValues && JSON.stringify(newProps.defaultValues) !== JSON.stringify(this.state.data)){

      const data = newProps.valueOverride ? newProps.defaultValues : Object.assign({}, this.state.data);
      this.setState({ data });
    }
  }

  onValueChange(obj){
    const data = Object.assign({}, this.state.data, obj);
    this.setState({ data }, this.executeSearch);
  }

  executeSearch(){
    if (this.props.disabled) {
      return;
    }

    let searchParams = Object.assign({}, this.state.data);
    this.props.searchAction(searchParams);
  }

  renderFields(){
    return React.Children.map(this.props.children, (child) => {
      if (child.type === 'div'){
        return child;
      } else {
        return React.cloneElement(child, {
          onValueChange: this.onValueChange,
          data: this.state.data,
          valueChangeDelay: this.props.valueChangeDelay,
          disabled: this.props.disabled
        });
      }
    }, this);
  }

  render() {
    return (
      <form className={this.props.className} role="form">
        {this.renderFields()}
      </form>);
  }
}
